/**Nhap danh muc chu tau */
import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormLabel,
  OutlinedInput,
  InputBase,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
} from "@mui/material";
import { makeStyles, withStyles } from "@mui/styles";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DatePicker } from "@mui/lab";
import SelectFilter from "react-select";
import { filterStyles } from "../components/common";
import QuyenPhanMemDialog from "./QuyenPhanMemDialog";

const myLib = require("../lib/MyLib");
const server = require("../lib/server");

const validator = require("../data/DangKy_Validator");

const styles = (theme) => ({
  red: {
    color: "white",
    backgroundColor: "#fc9003",
  },
  blue: {
    color: "white",
    backgroundColor: "#0384fc",
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  quantrong: {
    fontWeight: "bold !important",
  },
  colorBlue: {
    color: "blue",
  },
});

const fields = [
  "MaCang",
  "MaKV",
  "TenCang",
  "TenCang_TA",
  "MoTa",
  "MoTa_TA",
  "LoaiCang",
  "PhiNeo",
  "PhiDV",
  "Website",
  "STT",
  "HoatDong",
];

function isEmpty(v) {
  return v === undefined || v === null || v + "" === "";
}
function isZero(v) {
  return v === undefined || v === null || parseFloat(v) <= 0;
}
function validate_Empty(data, fields) {
  var ret = {};
  fields.map((name, index) => {
    if (isEmpty(data[name])) {
      ret[name] = true;
    }
  });
  return ret;
}
function validate_ChuTau(data) {
  var ret = validate_Empty(data, ["BRCD", "USCD", "USNM", "USCD_AD", "EMAIL"]);
  data.USCD_AD = data.USCD;
  if (Object.keys(ret).length == 0) {
    //ko co loi thi kiem tra cac dieu kien khac
    data.USCD = data.USCD.toUpperCase();
    data.USCD_AD = data.USCD_AD.toUpperCase();
    if (data.PWD1 !== "" && data.PWD1 !== data.PWD2) {
      ret.PWD2 = true;
    }
    data.PWD = data.PWD1;
  }

  ret.error = Object.keys(ret).length > 0;
  ret.GUID = new Date(); //danh dau version
  return ret;
}

class UserEditDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validateStatus: { error: false }, //trang thai validate
      source_danhmuc: {},
      source_donvi: props.DanhMucDonVi,
      after: {
        BRCD: props.MaDonVi,
        USCD: "",
        USNM: "",
        EMAIL: "",
        USCD_AD: "",
        ACTIVE: 1,
        PWD: "",
        PWD1: "",
        PWD2: "",
        ...(props.edittingRecord ? props.edittingRecord : {}),
      },
      open_show_quyen_phanmem: false, //hien thi form quyen phan mem
    };
  }

  componentDidMount() {
    //this.loadDanhMuc();
  }
  //call khi user thay doi trang
  static getDerivedStateFromProps(nextProps, prevState) {
    return { open: nextProps.open };
  }
  saveField = (fieldName, value) => {
    var old_changed = this.state.dataChanged;
    var s = { after: { ...this.state.after } }; //new value
    s.after[fieldName] = value;
    s.dataChanged = true;
    this.setState(s);
  };
  saveData = (obj) => {
    var old_changed = this.state.dataChanged;
    var s = {};
    s.dataChanged = true;
    s.canSaved = s.dataChanged;
    s.after = { ...this.state.after, ...obj };
    this.setState(s);
  };
  doSave = () => {
    var check = validate_ChuTau(this.state.after);
    if (!check.error) {
      this.setState({ validateStatus: check, saving: true, errorLog: "" });
      server
        .post("PhanQuyen/SaveUser", this.state.after)
        .then((response) => {
          var before = {};
          var after = {
            ...this.state.after,
          };
          Object.assign(before, after);
          this.setState({
            before: before,
            after: after,
            dataChanged: false,
            canSaved: false,
            saving: false,
            errorMessage: "",
            errorLog: "",
          });
          alert("Cập nhật thành công!");
          this.props.close(after);
        })
        .catch((error) => this.handleServerError(error));
    } else {
      this.setState({ validateStatus: check });
      toast.error("Vui lòng kiểm tra các trường đánh dấu đỏ!", {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
    }
  };
  handleServerError(error) {
    var message = "";
    var log = "";
    try {
      var obj = JSON.parse(error);
      message = obj.message;
      log = obj.traceLog;
      var log_detail = JSON.parse(log);

      if (log_detail && log_detail.Message) {
        message += "\n<br>" + log_detail.Message;
        if (log_detail.ExceptionMessage) {
          message = log_detail.ExceptionMessage + "\n" + message;
        }
      }
    } catch (e) {
      message = error + "";
    }
    toast.error(message, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
    });
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <Dialog
        open={this.props.open}
        maxWidth={"sm"}
        fullWidth={true}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Tài khoản</DialogTitle>
        <DialogContent>
          <div
            style={{
              minWidth: 500,
              minHeight: 30,
              padding: 5,
              fontSize: 10,
              wordWrap: "break-word",
            }}
          >
            <Grid container spacing={1} columns={24}>
              <Grid item xs={6}>
                <FormLabel>Bộ phận(*):</FormLabel>
              </Grid>
              <Grid item xs={18}>
                <Select
                  id="cboKV"
                  fullWidth
                  value={this.state.after.BRCD}
                  onChange={(event) => {
                    this.saveField("BRCD", event.target.value);
                  }}
                >
                  {this.state.source_donvi
                    ? this.state.source_donvi.map((item, index) => {
                        return (
                          <MenuItem key={item.BRCD} value={item.BRCD}>
                            {item.BRNM}
                          </MenuItem>
                        );
                      })
                    : null}
                </Select>
              </Grid>
              <Grid item xs={6}>
                <FormLabel>Tên đăng nhập(*):</FormLabel>
              </Grid>
              <Grid item xs={18}>
                <OutlinedInput
                  fullWidth
                  autoFocus
                  inputProps={{
                    className: classes.uppercaseText,
                    maxLength: 20,
                  }}
                  value={this.state.after.USCD}
                  readOnly={this.props.edittingRecord !== undefined}
                  onChange={(event) => {
                    this.saveData({
                      USCD: event.target.value,
                      USCD_AD: event.target.value,
                    });
                  }}
                  error={this.state.validateStatus.USCD !== undefined}
                />
              </Grid>
              <Grid item xs={6}>
                <FormLabel>Họ tên(*):</FormLabel>
              </Grid>
              <Grid item xs={18}>
                <OutlinedInput
                  fullWidth
                  autoFocus={this.props.edittingRecord !== undefined}
                  value={this.state.after.USNM}
                  onChange={(event) => {
                    this.saveField("USNM", event.target.value);
                  }}
                  error={this.state.validateStatus.USNM !== undefined}
                />
              </Grid>
              <Grid item xs={6}>
                <FormLabel>Email(*):</FormLabel>
              </Grid>
              <Grid item xs={18}>
                <OutlinedInput
                  fullWidth
                  value={this.state.after.EMAIL}
                  onChange={(event) => {
                    this.saveField("EMAIL", event.target.value);
                  }}
                  error={this.state.validateStatus.EMAIL !== undefined}
                />
              </Grid>

              {this.props.edittingRecord !== undefined ? null : (
                <>
                  <Grid item xs={6}>
                    <FormLabel>Mật khẩu:</FormLabel>
                  </Grid>
                  <Grid item xs={18}>
                    <OutlinedInput
                      fullWidth
                      value={this.state.after.PWD1}
                      type="password"
                      onChange={(event) => {
                        this.saveField("PWD1", event.target.value);
                      }}
                      error={this.state.validateStatus.PWD1 !== undefined}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormLabel>Nhắc lại MK:</FormLabel>
                  </Grid>
                  <Grid item xs={18}>
                    <OutlinedInput
                      fullWidth
                      value={this.state.after.PWD2}
                      type="password"
                      onChange={(event) => {
                        this.saveField("PWD2", event.target.value);
                      }}
                      error={this.state.validateStatus.PWD2 !== undefined}
                    />
                  </Grid>
                </>
              )}

              <Grid item xs={6}></Grid>
              <Grid item xs={18}>
                <FormControlLabel
                  label="Hoạt động"
                  labelPlacement="end"
                  fullWidth
                  control={
                    <Checkbox
                      size="medium"
                      sx={{ "& .MuiSvgIcon-root": { fontSize: 14 } }}
                      checked={this.state.after.ACTIVE > 0}
                      onChange={(event) =>
                        this.saveField("ACTIVE", event.target.checked ? 1 : 0)
                      }
                    />
                  }
                />
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              this.doSave();
            }}
            variant="contained"
          >
            Lưu
          </Button>
          <Button
            onClick={() => {
              if (this.props.close) {
                this.props.close(false);
              }
            }}
            variant="contained"
          >
            {this.props.confirm ? "CANCEL" : "Thoát"}
          </Button>
        </DialogActions>
        <ToastContainer
          position="top-right"
          autoClose={false}
          hideProgressBar
          newestOnTop={true}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover={false}
          style={{ fontSize: 12, width: 750 }}
          limit={5}
        />
      </Dialog>
    );
  }
}
export default withStyles(styles, { withTheme: true })(UserEditDialog);
